var DS_PREFIX = 'sol';
var getPrefixCls = function getPrefixCls(component) {
  return "".concat(DS_PREFIX, "-").concat(component);
};

export { getPrefixCls };
